import {
	POST_ENTITY,
	PATCH_ENTITY_BY_ID,
	GET_ENTITY,
	DELETE_ENTITY
} from '@/api/api.commons.js'
import Vue from 'vue'

export default {
	namespaced: true,
	state: {
		map: {},
	},
	getters: {
		mine_client_total(state) {
			return Object.keys(state.map).length
		},
		client(state) {
			return (id) => state.map[id]
		},
		clients(state) {
			return Object.keys(state.map).map(id => state.map[id])
		},
		search_clients(state) {
			return (name) => {
				if (!name || name.length === 0) {
					return Object.keys(state.map).map(id => state.map[id])
				}
				return Object.keys(state.map).filter(id => state.map[id].name.includes(name)).map(id => state.map[id])
			}
		},
	},
	mutations: {
		putToMap(state, {
			id,
			record
		}) {
			Vue.set(state.map, id, record)
		},
		removeFromMap(state, ids = []) {
			for (let id of ids) {
				Vue.delete(state.map, id)
			}
		},
		clearMap(state) {
			state.map = {}
		},
	},
	actions: {
		async delete_client({
			commit
		}, id) {
			await DELETE_ENTITY(`/systemClients/${id}`)
			commit("removeFromMap", [id])
		},

		async patch_client({
			commit
		}, {
			id,
			data = {}
		}) {
			const record = await PATCH_ENTITY_BY_ID({
				domain: 'systemClients',
				id,
				data,
			})
			id = record['id']
			commit("putToMap", {
				id,
				record
			})
		},

		async get_client({
			commit
		}, {
			id,
			params = {}
		}) {
			const record = await GET_ENTITY({
				uri: `/systemClients/${id}`,
				params
			})
			commit("putToMap", {
				id,
				record
			})
		},

		async create_client({
			commit
		}, data = {
		}) {
			const record = await POST_ENTITY({
				uri: '/systemClients',
				data,
			})
			let id = record['id']
			commit("putToMap", {
				id,
				record
			})
		},

		async get_mine_clients({
			commit,
			rootGetters
		}) {
			const uuid = rootGetters['system/account/uuid']
			if (!uuid) {
				return
			}
			const {
				_links: {
					createdSystemClients: {
						href: uri
					}
				}
			} = await GET_ENTITY({uri: `/systemUsers/${uuid}`})
			const {
			  _embedded: {
			    systemClients
			  }
			} = await GET_ENTITY({uri})
			for (let record of systemClients) {
				let id = record['id']
				commit("putToMap", {
					id,
					record
				})
			}
		},

		/**
		 * @description 用户登录后从持久化数据加载一系列的设置
		 * @param {Object} context
		 */
		async load({
			dispatch
		}, auth = true) {
			auth && dispatch('get_mine_clients')
		},
	}
}
